/** Created by azhou on 2019/3/14.*/
<template>
  <div id="addStaff">
    <public-title>编辑账号信息
      <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white p-4">
      <el-button
          v-if="positionLists.lists.length == 0" class="mt-3 mb-3"
          type="primary"
          @click="$router.push({name:'PositionManage'})">暂无职位，去添加</el-button>
      <div v-else>
        <el-tabs v-model="setType" type="card">
          <el-tab-pane label="基本信息" name="first">
            <div class="d-center mb-3 mt-5">
              <left-text-border leftText="姓名" class="w-50" v-model="accountInfo.truename"/>
              <div class="d-center-start ml-3 w-50">
                <left-text leftText="使用状态"/>
                <el-radio v-model="accountInfo.status" :label="'1'">启用</el-radio>
                <el-radio v-model="accountInfo.status" :label="'0'">禁用</el-radio>
              </div>
            </div>
            <div class="d-center-start mb-3">
              <left-text leftText="选择职位"/>
              <el-radio-group v-model="accountInfo.position_id" class="w-100 text-left">
                <el-radio  :disabled="disabledRadio( item.id)" :label="item.id" v-for="item in positionLists.lists" :key="item.id">{{item.name}}</el-radio>
              </el-radio-group>
            </div>
            <div class="d-start-start">
              <left-text leftText="选择门店"/>
              <div class="text-left">
                <el-tag class="mr-2 mb-2" v-for="tag in chooseStore" :key="tag.id" closable @close="closeTag(tag)">
                  {{tag.title}}
                </el-tag>
              </div>
            </div>
            <el-collapse accordion class="pl-2 text-left pl-2 mt-2" @change="getStoreUser" v-model="storeId">
              <el-collapse-item v-for="(item,index) in StoreLists.lists" :key="index" :name="item.id">
                <template slot="title">
                  <el-checkbox class="mr-2" v-model="item.checked" />
                  <div class="w-50">{{item.title}}</div>{{item.province_name+item.city_name}}
                </template>
                <div>详细地址：{{item.address}}</div>
                <div>当前负责人：<span class="text-muted" v-show="storeUser.length<=0">未设置负责人</span>
                  <span class="text-info mr-1" v-for="v in storeUser" :key="v.id">{{v.truename}}</span>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-tab-pane>
          <el-tab-pane label="修改手机" name="second">
            <div class="w-50 m-auto mt-5">
              <left-text-border type="number" leftText="原手机号" class="mt-3" disabled v-model="accountInfo.originMobile"/>
              <left-text-border type="number" leftText="新手机号" class="mt-3" v-model="accountInfo.new_mobile"/>
              <div class="d-center-start mt-3">
                <left-text leftText="验证码"/>
                <send-phone-code :phoneNumber="accountInfo.new_mobile"
                                @getCode="code => this.accountInfo.sms_code = code"
                                url="/pc/User/GetUpdateCode"
                                template="SMS_269200254" @showError="msg => _alert(msg,null,'error')"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="修改密码" name="third">
            <div class="w-50 m-auto mt-5">
              <left-text-border type="password" leftText="新密码" class="mt-3" v-model="accountInfo.pwd"/>
              <left-text-border type="password" leftText="确认密码" class="mt-3" v-model="accountInfo.pwd2"/>
              <div class="d-center-start mt-3">
                <left-text leftText="清空微信"/>
                <el-radio v-model="wx" label="0">否</el-radio>
                <el-radio v-model="wx" label="1">是</el-radio>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-button @click="editStaff" class="mt-4" type="primary">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'EditAccount',
    computed: {
      ...mapState(['StoreLists','positionLists','staffDetail']),
      ...mapGetters(['storeInfo','isGroup']),
      chooseStore() {           //已选择要管理的门店
        return this.StoreLists.lists.filter(v => v.checked);
      }
    },
    data() {
      return {
        accountInfo:{
          status:'1'
        },
        setType:'first',
        storeId:'',           //根据门店Id获取管理人信息
        storeUser:[],         //门店已绑定的负责人数组
        wx: '0'
      }
    },
    watch:{
      staffDetail() {
        this.accountInfo = {
          ...this.staffDetail,
          originMobile:this.staffDetail.mobile,
          status:this.staffDetail.status + '',      //转字符串
        };
        //深拷贝
        let lists = this.StoreLists.lists.map(v => { return {...v} })
        lists.forEach(v => {
          if (this.$GFUN.isInArray(this.staffDetail.store_ids,v.id)) v.checked = true
        });
        this.UPDATESTORELISTS({lists});
      },

    },
    async created() {
      this.getUserPositionLists();                    //获取职位列表
      await this.getUserStoreLists();                 //获取门店列表
      this.getStaffDetail(this.$route.query.account); //获取员工详情
    },
    methods:{
      ...mapMutations(['UPDATESTORELISTS']),
      ...mapActions(['getUserPositionLists','getUserStoreLists','getStoreLinkLists','editUserStaff','getStaffDetail']),
      //点击某一门店时获取该门店已添加的负责人信息
      async getStoreUser(value) {
        if (value) this.storeUser = await this.getStoreLinkLists(this.storeId);
      },
      //删除tag标签
      closeTag(item) {
        this.StoreLists.lists.forEach(v => {
          if (v.id === item.id) v.checked = false;
        });
      },
      /*表单验证函数*/
      validateFun() {
        switch (this.setType) {
          case 'first':
            if (!this.accountInfo.truename) return {code: false, msg: '请输入姓名'};
            if (this.chooseStore.length <= 0) return {code: false, msg: '请选择该人员管理的门店'};
            break;
          case 'second':
            if (!this.accountInfo.new_mobile) return {code: false, msg: '请填写手机号'};
            if (!this.accountInfo.sms_code) return {code: false, msg: '请输入验证码'};
            break;
          case 'third':
            if (!this.accountInfo.pwd || !this.accountInfo.pwd2) return {code: false, msg: '密码不得为空'};
            if (this.accountInfo.pwd !== this.accountInfo.pwd2) return {code: false, msg: '两次密码不一致'};
            break;
        }
        return {code: true, msg: '表单验证通过'}
      },
      //编辑账号
      editStaff() {
        let result = this.validateFun();
        if (result.code) {
          this._confirm('确定提交么？',() => {
            let data = {
              user_id: this.accountInfo.uid,
              pwd: '',
              pwd2: '',
              wechat_flag: this.wx,
              ...this.accountInfo,
            }
            delete data.originMobile;
            if (this.setType !== 'second') delete data.code;
            // if (this.wx == 1) delete data.wechat_flag;
            this.editUserStaff({
              ...data,
              store_ids:this.chooseStore.map(item => item.id),
            })
          })
        } else this._alert(result.msg,null,'error');
      },
      //判断选择职位不可选
      disabledRadio(id){
        let n=false;
          switch (this.storeInfo.type) {
            case 2:
            if(!this.isGroup){
              if(id==1||id==6){n=true}
            }else{
              if(id==6){n=true}
            }
            break;
            case 3:
              if(!this.isGroup){
                if(id==3||id==7){n=true}
              }else{
                if(id==7){n=true}
              }
            break;
            default:return '';
          }
          return n
      }
    }
  }
</script>
<style lang="scss">
  .get-code{
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
</style>
